/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

const Review = () => {
  return (
      <div className="dashboard_content">
        <div className="dashboard_body dashboard_review">
          <h3>review</h3>
          <div className="review_area">
            <div className="comment pt-0 mt_20">
              <div className="single_comment m-0 border-0">
                <img
                  src="images/menu2_img_4.jpg"
                  alt="review"
                  className="img-fluid"
                />
                <div className="single_comm_text">
                  <h3>
                    <a>mamun ahmed shuvo</a> <span>29 oct 2022 </span>
                  </h3>
                  <span className="rating">
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                    <i className="fad fa-star-half-alt" />
                    <i className="fal fa-star" />
                    <b>(120)</b>
                  </span>
                  <p>
                    Sure there isn't anything embarrassing hiidden in the
                    middles of text. All erators on the Internet tend to repeat
                    predefined chunks
                  </p>
                  <span className="status active">active</span>
                </div>
              </div>

              <div className="pagination mt_30">
                <div className="row">
                  <div className="col-12">
                    <nav aria-label="...">
                      <ul className="pagination">
                        <li className="page-item">
                          <a className="page-link" href="#">
                            <i className="fas fa-long-arrow-alt-left" />
                          </a>
                        </li>
                        <li className="page-item">
                          <a className="page-link" href="#">
                            1
                          </a>
                        </li>
                        <li className="page-item active">
                          <a className="page-link" href="#">
                            2
                          </a>
                        </li>
                        <li className="page-item">
                          <a className="page-link" href="#">
                            3
                          </a>
                        </li>
                        <li className="page-item">
                          <a className="page-link" href="#">
                            <i className="fas fa-long-arrow-alt-right" />
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Review;
